import { render, staticRenderFns } from "./OrderReturnDetail.vue?vue&type=template&id=59b16e9e&scoped=true"
import script from "./OrderReturnDetail.vue?vue&type=script&lang=ts"
export * from "./OrderReturnDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrderReturnDetail.vue?vue&type=style&index=0&id=59b16e9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b16e9e",
  null
  
)

export default component.exports